import { ReactNode } from "react";

export enum LinkType {
  interactive = "interactive",
  neutral = "neutral",
  subtle = "subtle",
}

export interface LinkProps {
  label: string;
  onClick?: () => void;
  type?: LinkType | `${LinkType}`;
  icon?: ReactNode;
  iconPosition?: "left" | "right";
}

const textColors: Record<LinkType, string> = {
  interactive: "text-text-interactive-base hover:text-text-interactive-hover active:text-text-interactive-pressed",
  neutral: "text-text-base hover:text-text-subtle active:text-text-base",
  subtle: "text-text-subtle hover:text-text-subtle active:text-text-subtle",
};

const iconColors: Record<LinkType, string> = {
  interactive: "text-icon-interactive hover:text-icon-interactive-hover active:text-icon-interactive-pressed",
  neutral: "text-icon-bg-base hover:text-icon-bg-subtle active:text-icon-bg-base",
  subtle: "text-icon-bg-subtle hover:text-icon-bg-subtle active:text-icon-bg-subtle",
};

const Link = ({
  label, type = LinkType.interactive, iconPosition = "left", icon, onClick,
}: LinkProps) => (
  <button onClick={onClick} className={`flex w-fit items-center typography-medium-base space-x-1 ${iconColors[type]}`} type="button">
    {icon && iconPosition === "left" && icon}
    <span className={`${textColors[type]}`}>{label}</span>
    {icon && iconPosition === "right" && icon}
  </button>
);

export default Link;
